"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var ColumnSelect_exports = {};
__export(ColumnSelect_exports, {
  default: () => ColumnSelect_default
});
module.exports = __toCommonJS(ColumnSelect_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.50002 3.0999C5.72683 3.0999 5.10002 3.7267 5.10002 4.4999V6.64276C5.10002 6.97413 4.8314 7.24276 4.50002 7.24276C4.16865 7.24276 3.90002 6.97413 3.90002 6.64276V4.4999C3.90002 3.06396 5.06408 1.8999 6.50002 1.8999H8.07145C8.40282 1.8999 8.67145 2.16853 8.67145 2.4999C8.67145 2.83127 8.40282 3.0999 8.07145 3.0999H6.50002ZM9.8286 2.4999C9.8286 2.16853 10.0972 1.8999 10.4286 1.8999H13.5715C13.9028 1.8999 14.1715 2.16853 14.1715 2.4999C14.1715 2.83127 13.9028 3.0999 13.5715 3.0999H10.4286C10.0972 3.0999 9.8286 2.83127 9.8286 2.4999ZM15.3286 2.4999C15.3286 2.16853 15.5972 1.8999 15.9286 1.8999H17.5C18.936 1.8999 20.1 3.06396 20.1 4.4999V6.64276C20.1 6.97413 19.8314 7.24276 19.5 7.24276C19.1687 7.24276 18.9 6.97413 18.9 6.64276V4.4999C18.9 3.7267 18.2732 3.0999 17.5 3.0999H15.9286C15.5972 3.0999 15.3286 2.83127 15.3286 2.4999ZM19.5 9.25704C19.8314 9.25704 20.1 9.52567 20.1 9.85704V14.1428C20.1 14.4741 19.8314 14.7428 19.5 14.7428C19.1687 14.7428 18.9 14.4741 18.9 14.1428V9.85704C18.9 9.52567 19.1687 9.25704 19.5 9.25704ZM4.50002 9.25705C4.8314 9.25705 5.10002 9.52567 5.10002 9.85705V14.1428C5.10002 14.4741 4.8314 14.7428 4.50002 14.7428C4.16865 14.7428 3.90002 14.4741 3.90002 14.1428V9.85705C3.90002 9.52567 4.16865 9.25705 4.50002 9.25705ZM19.5 16.757C19.8314 16.757 20.1 17.0257 20.1 17.357V19.4999C20.1 20.9358 18.936 22.0999 17.5 22.0999H15.9286C15.5972 22.0999 15.3286 21.8313 15.3286 21.4999C15.3286 21.1685 15.5972 20.8999 15.9286 20.8999H17.5C18.2732 20.8999 18.9 20.2731 18.9 19.4999V17.357C18.9 17.0257 19.1687 16.757 19.5 16.757ZM4.50002 16.757C4.8314 16.757 5.10002 17.0257 5.10002 17.357V19.4999C5.10002 20.2731 5.72683 20.8999 6.50002 20.8999H8.07145C8.40282 20.8999 8.67145 21.1685 8.67145 21.4999C8.67145 21.8313 8.40282 22.0999 8.07145 22.0999H6.50002C5.06408 22.0999 3.90002 20.9358 3.90002 19.4999V17.357C3.90002 17.0257 4.16865 16.757 4.50002 16.757ZM9.8286 21.4999C9.8286 21.1685 10.0972 20.8999 10.4286 20.8999H13.5715C13.9028 20.8999 14.1715 21.1685 14.1715 21.4999C14.1715 21.8313 13.9028 22.0999 13.5715 22.0999H10.4286C10.0972 22.0999 9.8286 21.8313 9.8286 21.4999ZM8 6.5C8 5.94772 8.44772 5.5 9 5.5H15C15.5523 5.5 16 5.94772 16 6.5V9.5C16 10.0523 15.5523 10.5 15 10.5H9C8.44772 10.5 8 10.0523 8 9.5V6.5ZM9 13.5C8.44772 13.5 8 13.9477 8 14.5V17.5C8 18.0523 8.44772 18.5 9 18.5H15C15.5523 18.5 16 18.0523 16 17.5V14.5C16 13.9477 15.5523 13.5 15 13.5H9Z",
      fill: "currentColor"
    }
  )
);
const SvgColumnSelect = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var ColumnSelect_default = SvgColumnSelect;
